import { useEffect, useState } from "react";
import { generateDynamicLink } from "@/services/general-service";

interface UseDynamicLinkOptions {
  enabled?: boolean;
  url: string | null;
  title: string;
  description: string;
  image: string;
}

export function useDynamicLink({
  enabled = true,
  url,
  title,
  description,
  image,
}: UseDynamicLinkOptions) {
  const [link, setLink] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    if (!enabled || !url) return;
    //   if (!isOpen) return;
    // if (!activity?.id) return;
    if (typeof window === "undefined") return;

    let cancelled = false;

    const fetchLink = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const res = await generateDynamicLink({
          url,
          title,
          description,
          image,
        });

        if (!cancelled) {
          setLink(res?.shortUrl ?? null);
        }
      } catch (e) {
        if (!cancelled) {
          console.error("Dynamic link error:", e);
          setError(e);
          setLink(null);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchLink();

    return () => {
      cancelled = true;
    };
  }, [enabled, url, title, description, image]);

  return {
    link,
    isLoading,
    error,
    refetch: () => {
      if (url) {
        setLink(null);
      }
    },
  };
}
